// extracted by mini-css-extract-plugin
export default {"cellAlign":"cellAlign---oTJ5i"};